export default (
  cb: (key: string, value: any) => { [key: string]: any }
) => (obj: { [key: string]: any }) =>  Object.keys(obj).map(k => cb(k, obj[k]));
